import { render, staticRenderFns } from "./PackagingTypesUserPack.vue?vue&type=template&id=0b70e667&scoped=true"
import script from "./PackagingTypesUserPack.vue?vue&type=script&lang=js"
export * from "./PackagingTypesUserPack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70e667",
  null
  
)

export default component.exports